import Document from '../../models/Document'

export const DocumentsModule = {
  namespaced: true,

  state: {
    document: new Document({})
  },

  getters: {
    document (state) {
      return state.document
    }
  },

  mutations: {
    setDocument (state, document) {
      state.document = new Document(document)
    }
  }
}

export default DocumentsModule